import { Button } from "antd";
import emptyBox from "assets/images/empty-box-transparent.svg";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { AppURL } from "utils/Actions";
import style from "./styles.module.scss";

export default function EASClosed() {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <div className={style.container}>
      <div className={style["text-container"]}>
        <img src={emptyBox} alt="" style={{ marginBottom: 8 }} />
        <h1>{t("easApplications.easClosed.title")}</h1>
        <p style={{ marginBottom: 24 }}>{t("easApplications.easClosed.content")}</p>
        <Button
          type="primary"
          style={{ width: "max-content" }}
          onClick={() => history.push(`${AppURL.school.path}`)}
          aria-label="Go back to home dashboard"
        >
          {t("easApplications.easClosed.homeCTA")}
        </Button>
      </div>
    </div>
  );
}
